// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__37By1","modalForm":"UpgradeEpcsModal_modalForm__2iPaB","modalFooter":"UpgradeEpcsModal_modalFooter__38Rgv"};